import { Component } from 'react'
import PropTypes from 'prop-types'
import Nav from './nav'
import SubNav from './sub_nav'

export default class Menu extends Component {
  static propTypes = {
    mainNavItems: PropTypes.array,
    subNavItems: PropTypes.array,
    section: PropTypes.string,
    subSection: PropTypes.string,
    wrapperClass: PropTypes.string,
    mainNavClass: PropTypes.string,
    subNavClass: PropTypes.string,
  }

  static defaultProps = {
    mainNavItems: [],
    subNavItems: [],
    section: null,
    subSection: null,
    wrapperClass: 'tabbed-nav',
    mainNavWrapperClass: 'tabbed-nav__navigation',
    subNavWrapperClass: 'tabbed-nav__navigation tabbed-nav__navigation--sub',
  }

  getMainNavContent() {
    const { mainNavItems, section, mainNavClass } = this.props
    if (mainNavItems.length > 0) {
      return <Nav mode="main" key="main-nav" items={mainNavItems} section={section} navClass={mainNavClass} />
    }
    return null
  }

  getSubNavContent() {
    const { subNavItems, subSection, subNavClass } = this.props
    if (subNavItems.length > 0) {
      return <SubNav key="sub-nav" items={subNavItems} section={subSection} navClass={subNavClass} />
    }
    return null
  }

  render() {
    const { wrapperClass } = this.props
    const mainNav = this.getMainNavContent()
    const subNav = this.getSubNavContent()
    return (
      <div className={wrapperClass}>
        {mainNav}
        {subNav}
      </div>
    )
  }
}
